<template>
  <div>
    <v-card-subtitle class="mt-0 mb-0 pb-0 pt-1">
      <v-row no-gutters>
        <v-col cols="1" class="pt-1">
          <v-icon>mdi-file-document</v-icon>
        </v-col>
        <v-col cols="10" style="min-width: 0">
          <v-btn
            text
            class="text-capitalize grey--text text--darken-2"
            @click="openDocument(document)"
            :target="target"
            :disabled="!document.is_readable"
            small
            style="
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            {{ document.title }}
          </v-btn>
        </v-col>
        <v-col cols="1">
          <v-btn
            class="float-right"
            text
            x-small
            @click="deleteDocument(document.uuid)"
            :disabled="!(!isReadOnly && document.is_removable)"
          >
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col offset="1" cols="11">
          <span v-if="isReadOnly">
            <v-chip
              v-for="(category, index) in document.categories"
              :key="index"
              class="mx-1"
            >
              {{ category }}
            </v-chip>
          </span>
        </v-col>
      </v-row>
    </v-card-subtitle>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import api from "@/utils/api";

export default {
  name: "DocumentComponent",
  props: {
    document: {
      type: Object,
      default: Object,
    },
    readonly: {
      type: Boolean,
      default: Boolean,
    },
  },

  computed: {
    ...mapGetters(["getIframeStatus"]),
    target() {
      return !this.getIframeStatus ? "_blank" : "";
    },
    isReadOnly() {
      return !!this.readonly;
    },
  },
  data: () => ({}),
  created() {},
  methods: {
    openDocument(item) {
      api.getDocument(item.uuid).then((resp) => {
        let routeData = this.$router.resolve({
          name: "documentsDetails",
          params: { id: item.uuid },
        });
        !this.getIframeStatus
          ? window.open(routeData.href, "_blank")
          : window.open(routeData.href, "_self");
      });
    },
    deleteDocument(document) {
      this.$emit("delete-document", document);
    },
  },
};
</script>
